import { appendElement } from '../xml-helpers';

export function buildCrossmark(
  parent: Element,
  crossmarkPolicyPage: string,
  updateType: string,
  updateDate: string,
  updatedArticleDoi: string
): Element {
  const crossmark = appendElement(parent, 'crossmark');

  appendElement(crossmark, 'crossmark_policy', crossmarkPolicyPage);

  const updates = appendElement(crossmark, 'updates');
  appendElement(updates, 'update', updatedArticleDoi, {
    type: updateType,
    date: updateDate,
  });

  return crossmark;
}
